"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFilterData = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var util_1 = require("../../util");
var FilterDropdown_1 = tslib_1.__importDefault(require("./FilterDropdown"));
function collectFilterStates(columns, init, pos) {
    var filterStates = [];
    (columns || []).forEach(function (column, index) {
        var _a;
        var columnPos = (0, util_1.getColumnPos)(index, pos);
        if ('children' in column) {
            filterStates = tslib_1.__spreadArray(tslib_1.__spreadArray([], tslib_1.__read(filterStates), false), tslib_1.__read(collectFilterStates(column.children, init, columnPos)), false);
        }
        else if (column.filters || 'filterDropdown' in column || 'onFilter' in column) {
            if ('filteredValue' in column) {
                // Controlled
                var filteredValues = column.filteredValue;
                if (!('filterDropdown' in column)) {
                    filteredValues = (_a = filteredValues === null || filteredValues === void 0 ? void 0 : filteredValues.map(String)) !== null && _a !== void 0 ? _a : filteredValues;
                }
                filterStates.push({
                    column: column,
                    key: (0, util_1.getColumnKey)(column, columnPos),
                    filteredKeys: filteredValues,
                    forceFiltered: column.filtered,
                });
            }
            else {
                // Uncontrolled
                filterStates.push({
                    column: column,
                    key: (0, util_1.getColumnKey)(column, columnPos),
                    filteredKeys: init && column.defaultFilteredValue ? column.defaultFilteredValue : undefined,
                    forceFiltered: column.filtered,
                });
            }
        }
    });
    return filterStates;
}
function injectFilter(prefixCls, dropdownPrefixCls, columns, filterStates, triggerFilter, getPopupContainer, locale, pos) {
    return columns.map(function (column, index) {
        var columnPos = (0, util_1.getColumnPos)(index, pos);
        var _a = column.filterMultiple, filterMultiple = _a === void 0 ? true : _a;
        var newColumn = column;
        if (newColumn.filters || newColumn.filterDropdown) {
            var columnKey_1 = (0, util_1.getColumnKey)(newColumn, columnPos);
            var filterState_1 = filterStates.find(function (_a) {
                var key = _a.key;
                return columnKey_1 === key;
            });
            newColumn = tslib_1.__assign(tslib_1.__assign({}, newColumn), { title: function (renderProps) { return (React.createElement(FilterDropdown_1.default, { prefixCls: "".concat(prefixCls, "-filter"), dropdownPrefixCls: dropdownPrefixCls, column: newColumn, columnKey: columnKey_1, filterState: filterState_1, filterMultiple: filterMultiple, triggerFilter: triggerFilter, locale: locale, getPopupContainer: getPopupContainer }, (0, util_1.renderColumnTitle)(column.title, renderProps))); } });
        }
        if ('children' in newColumn) {
            newColumn = tslib_1.__assign(tslib_1.__assign({}, newColumn), { children: injectFilter(prefixCls, dropdownPrefixCls, newColumn.children, filterStates, triggerFilter, getPopupContainer, locale, columnPos) });
        }
        return newColumn;
    });
}
function flattenKeys(filters) {
    var keys = [];
    (filters || []).forEach(function (_a) {
        var value = _a.value, children = _a.children;
        keys.push(value);
        if (children) {
            keys = tslib_1.__spreadArray(tslib_1.__spreadArray([], tslib_1.__read(keys), false), tslib_1.__read(flattenKeys(children)), false);
        }
    });
    return keys;
}
function generateFilterInfo(filterStates) {
    var currentFilters = {};
    filterStates.forEach(function (_a) {
        var key = _a.key, filteredKeys = _a.filteredKeys, column = _a.column;
        var filters = column.filters, filterDropdown = column.filterDropdown;
        if (filterDropdown) {
            currentFilters[key] = filteredKeys || null;
        }
        else if (Array.isArray(filteredKeys)) {
            var keys = flattenKeys(filters);
            currentFilters[key] = keys.filter(function (originKey) { return filteredKeys.includes(String(originKey)); });
        }
        else {
            currentFilters[key] = null;
        }
    });
    return currentFilters;
}
function getFilterData(data, filterStates) {
    return filterStates.reduce(function (currentData, filterState) {
        var _a = filterState.column, onFilter = _a.onFilter, filters = _a.filters, filteredKeys = filterState.filteredKeys;
        if (onFilter && filteredKeys && filteredKeys.length) {
            return currentData.filter(function (record) {
                return filteredKeys.some(function (key) {
                    var keys = flattenKeys(filters);
                    var keyIndex = keys.findIndex(function (k) { return String(k) === String(key); });
                    var realKey = keyIndex !== -1 ? keys[keyIndex] : key;
                    return onFilter(realKey, record);
                });
            });
        }
        return currentData;
    }, data);
}
exports.getFilterData = getFilterData;
function useFilter(_a) {
    var prefixCls = _a.prefixCls, dropdownPrefixCls = _a.dropdownPrefixCls, mergedColumns = _a.mergedColumns, onFilterChange = _a.onFilterChange, getPopupContainer = _a.getPopupContainer, tableLocale = _a.locale;
    var _b = tslib_1.__read(React.useState(collectFilterStates(mergedColumns, true)), 2), filterStates = _b[0], setFilterStates = _b[1];
    var mergedFilterStates = React.useMemo(function () {
        var collectedStates = collectFilterStates(mergedColumns, false);
        // Return if not controlled
        if (collectedStates.every(function (_a) {
            var filteredKeys = _a.filteredKeys;
            return filteredKeys === undefined;
        })) {
            return filterStates;
        }
        return collectedStates;
    }, [mergedColumns, filterStates]);
    var getFilters = React.useCallback(function () { return generateFilterInfo(mergedFilterStates); }, [mergedFilterStates]);
    var triggerFilter = function (filterState) {
        var newFilterStates = mergedFilterStates.filter(function (_a) {
            var key = _a.key;
            return key !== filterState.key;
        });
        newFilterStates.push(filterState);
        setFilterStates(newFilterStates);
        onFilterChange(generateFilterInfo(newFilterStates), newFilterStates);
    };
    var transformColumns = function (innerColumns) {
        return injectFilter(prefixCls, dropdownPrefixCls, innerColumns, mergedFilterStates, triggerFilter, getPopupContainer, tableLocale);
    };
    return [transformColumns, mergedFilterStates, getFilters];
}
exports.default = useFilter;
//# sourceMappingURL=index.js.map